Wee.routes.addFilter({
	'isPaginated': function(seg) {
		return /^p\d+$/.test(seg);
	},
	'notPaginated': function(seg) {
		return seg && ! /^p\d+$/.test(seg);
	}
});

Wee.routes.map({
	'$root': 'index',
	'$any': [
		'common',
		'cart',
		'miniCart',
		'navigation'
	],
	'$any:once': [
		'common:alert',
		'header',
		'footer'
	],
	'about': 'about',
	'about:unload': 'about:unload',
	'faq': {
		'$root||$isPaginated': ['accordion', 'faq'],
		'$slug:unload': 'resourcesDetail:unload'
	},
	'faq:unload': 'accordion:unload',
	'gallery': {
		'$root||$slug': 'gallery'
	},
	'gallery:unload': 'gallery:unload',
	'search-results': 'search',
	'search-results:unload': 'search:unload',
	'resources': {
		'$root': 'resources',
		'$isPaginated': 'resources',
		'$slug:unload': 'resourcesDetail:unload'
	},
	'resources:unload': 'resources:unload',
	'products': {
		'$root': 'products',
		'$slug': {
			'$root': 'products',
			'$isPaginated': {
				'$root': 'products'
			},
			'$notPaginated': ['productEntry', 'share'],
			'$notPaginated:unload': ['productEntry:unload', 'share:unload']
		}
	},
	'products:unload': 'products:unload',
	'planning': {
		'$slug': 'planning',
		'$slug:unload': 'planning:unload'
	},
	'promotions': {
		'$root': 'promotionsIndex',
		'$root:unload': 'promotionsIndex:unload',
		'$slug': 'promotions',
		'$slug:unload': 'promotions:unload'
	},
	'stories': {
		'$root||$isPaginated:once': 'stories',
		'$slug': 'swiper',
		'$slug:unload': 'swiper:unload'
	},
	'quote': {
		'$root': 'storage:get'
	},
	'quote-form': 'quoteForm'
});

Wee.ready('routes:run');
